module.exports = __webpack_public_path__ + "static/img/top.89f4d979.webp";